// extracted by mini-css-extract-plugin
module.exports = {"com-jp":"ComJP_com-jp__XHrtX","swiperTool":"ComJP_swiperTool__gLpBS"};